// extracted by mini-css-extract-plugin
module.exports = {"nav_box":"nav_box-zJehakhi","main_nav":"main_nav-1JWeRfUS","box":"box-4X8HPJE4","ad":"ad-1Z6do0zx","search":"search-2xk4n2Si","logo":"logo-SNIVOVft","userinfo":"userinfo-28mQ2_3J"};